<template>
<div id="home">
  <my-header></my-header>
  <div class="pd20">
    <loading v-if="loading" :text="'Please wait'|translate"></loading>
    <div v-if="garden">
      <div>
        <h3 class="mt0 inline">{{'Garden'|translate}}</h3>
      </div>
      
      <div class="row mt20" v-if="!loading" >
        <div class="col-md-6 mt10">
          <label>{{'Name'|translate}}:</label>
          <p>{{garden.name}}</p>

          
          <p v-if="!garden.name">{{'No information'|translate}}</p>
          
          <div v-if="garden.commune_name">
            <label class="mt10">{{'Address'|translate}}:</label>
            <p>{{ garden.commune_name }},{{ garden.district_name }},{{ garden.province_name }}</p>
          </div>
          
          <label class="mt10">{{'Certificate'|translate}}:</label>
          <p v-if="garden.certificate">
            {{garden.certificate}}
            <span v-if="garden.is_converting" >({{ 'Is converting'|translate}})</span> 
            </p>
          <p v-if="!garden.certificate">{{'No information'|translate}}</p>
<!-- 
          <div v-if="garden.certificate"> 
          <label class="mt10">{{ 'Is converting'|translate}}:</label>
         
          <p>{{ garden.is_converting ? 'Có' : 'Không'}}</p>
          </div> -->
          
          <img v-if="garden.feature_image" :src="garden.feature_image" />
        </div>
        <!-- end col-md-6 -->
        <div class="col-md-6 mt10">
          <p>
            <router-link  :to="{ name: 'Profile',params: { profileId: garden.user_id }}"><i class="fas fa-user-tie"></i> {{'Owner Profile'|translate}}</router-link>
          </p>
          <label>{{'Products available in garden'|translate}}:</label>
          <p v-if="available_products.length==0">{{'No product'|translate}}</p>
          <div class="list-tags">
            <a class="mytag selected" v-for="(product) in available_products" :key="product.id">{{product.name}}</a>
          </div>
          <p class="mt10 mb0"><label>Mã QR:</label></p>

        <qrcode :value="getLink()" tag="img" :options="{ width: size }"></qrcode>
        <p><small>Bạn có thể dùng mã code này để chia sẻ link</small</p>
          <div v-if="garden.garden_location">
            <label class="mt10">Vị trí vườn:</label>
            <p><a target="_blank" :href="'https://www.google.com/maps?q='+garden.garden_location[0]+','+garden.garden_location[1]">{{garden.garden_address}}</a></p>
            <div id="map"></div>
          </div>

        </div>
        <!-- end col-md-6 -->
      </div>
    </div>

  </div>
  <!-- end pd20 -->
</div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Loading from '@/components/elements/Loading'
export default {
  name: 'garden',
  components: {
    MyHeader,
    Loading
  },
  data () {
    return {
      loading: true,
      garden:null,
      available_products : [],
      value: 'https://example.com',
      size: 120
    }
  },
  watch: {
    $route(to, from) {
      console.log('from',from)
      console.log('to',to)
      this.loadInfo()
    },
  },
  methods: {
    getLink (){
      return window.location.href
    },
    initMap: function () {
      if (typeof google !== 'undefined') {
        document.getElementById('map').style.height = 400
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: this.garden.location[0], lng: this.garden.location[1]},
          zoom: 12,
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER
          },
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER
          },
          scaleControl: true,
          streetViewControl: true,
          streetViewControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP
          },
          fullscreenControl: true
        })
        let centerPoint = {lat: this.garden.location[0], lng: this.garden.location[1]}
        let image = '/static/images/pin_orange.png'
        let marker = new google.maps.Marker({
          position: centerPoint,
          map: this.map,
          label: '',
          title: this.$t('My Location'),
          icon: image,
          infowindow: new google.maps.InfoWindow({
            content: this.garden.name
          })
        })

      } else {
        setTimeout(() => {
          this.initMap()
        }, 10)
      }
    },
    loadInfo(){
      this.loading = true
      this.garden = null
      let gardenId = this.$route.params.gardenId

    let wating = [Utils.getAllProducts(this, {})];
          let data = {
        offset: 0,
        limit: 1,
        id: gardenId
      };

      wating.push(Utils.request(this, true, "garden").get(
        `/getGarden/${gardenId}`
      ))

    Promise.all(wating).then(values => {
        
        this.all_products=  values[0]
        this.garden = values[1].data.data;
        console.log('this.garden',this.garden)
        this.available_products = this.all_products.filter( item => {return this.garden.product_ids.indexOf(item.id) != -1} )
        this.loading = false        
    })

    }
  },
  mounted () {
    this.loadInfo()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile/ProfileGarden.vue